import React, { createContext, useContext, useEffect } from 'react';
import { useProductsSearch } from './useProductsSearch';

type ProductsSearchValue = ReturnType<typeof useProductsSearch>;

const ProductsSearchContext = createContext<ProductsSearchValue | null>(null);

/** Uma única instância de busca de produtos para ProductSelector e CompetitorSelector; prefetch ao montar a área de filtros. */
export const ProductsSearchProvider = ({ children }: { children: React.ReactNode }) => {
  const value = useProductsSearch();

  useEffect(() => {
    value.handleOpen();
  }, [value.handleOpen]);

  return <ProductsSearchContext.Provider value={value}>{children}</ProductsSearchContext.Provider>;
};

export const useProductsSearchContext = (): ProductsSearchValue => {
  const ctx = useContext(ProductsSearchContext);
  if (!ctx) {
    throw new Error('useProductsSearchContext must be used within ProductsSearchProvider');
  }
  return ctx;
};
